export default __webpack_public_path__ + "static/ourWorks_heder-5c6213806b032fc53010f7195c5eeca3.png";